import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

import { getDataByUrl } from "@/handlers/commonApi";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";

import { useContext } from "react";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  constituencyListData = null,
}) {
  const masterConfig = useContext(MasterConfigContext);
  const biharElectionKey = masterConfig["tamil_nadu_election"];
  const resultYear = biharElectionKey?.resultPageMetaYear || "2026";
  const isMobileDevice = useIsMobile();
  const oldResult = {
    partyData: [
      {
        color: "#FF9933",
        partyName: "AIADMK+",
        partySeat: "75",
      },
      {
        color: "#19AAED",
        partyName: "DMK+",
        partySeat: "157",
      },
      {
        color: "#19AAED",
        partyName: "AMMK+",
        partySeat: "0",
      },
      {
        color: "#19AAED",
        partyName: "MNM+",
        partySeat: "0",
      },
      {
        color: "#CC0000",
        partyName: "OTH",
        partySeat: "2",
      },
    ],
  };
  const oldDesc = `Tamil Nadu Assembly Elections 2026: क्या स्टालिन बचा पाएंगे अपना किला या विजय का 'तमिलगा वैट्री कड़गम' बिगाड़ेगी समीकरण? तमिलनाडु की सभी 234 विधानसभा सीटों पर इस बार मुकाबला बेहद दिलचस्प होने वाला है. इस बार राज्य में 23 अप्रैल को एक ही चरण में वोटिंग होगी. साल 2021 के नतीजों की बात करें तो एमके स्टालिन के नेतृत्व वाले DMK (द्रविड़ मुनेत्र कड़गम) के नेतृत्व वाली SPA (Secular Progressive Alliance) गठबंधन ने 159 सीटें जीतकर 10 साल बाद सत्ता में वापसी की थी, जिसमें DMK ने अकेले 133 सीटें हासिल की थीं. इस गठबंधन में शामिल कांग्रेस पार्टी को 18, VCK को 4, CPI को 2 और CPI (M) को 2 सीटें मिलीं. वहीं BJP के नेतृत्व वाली NDA को 75 सीटें हासिल हुईं जिसमें AMMK (अम्मा मक्कल मुनेत्र कड़गम) 66 सीटों, PMK 5 और BJP को 4 सीटें मिलीं. इस बार का चुनाव इसलिए खास है क्योंकि सुपरस्टार विजय अपनी नई पार्टी 'तमिलगा वैट्री कड़गम' (TVK) के साथ चुनावी मैदान में उतर चुके हैं. विजय ने किसी भी गठबंधन का हिस्सा बनने से इनकार करते हुए सभी 234 सीटों पर अकेले चुनाव लड़ने का ऐलान किया है, जिससे मुकाबला काफी दिलचस्प होने वाला है. एक तरफ जहां मुख्यमंत्री स्टालिन अपने कल्याणकारी कामों के दम पर सत्ता बरकरार रखना चाहते हैं, वहीं एडप्पादी के. पलानीस्वामी (EPS) के नेतृत्व वाली AIADMK और बीजेपी का गठबंधन सत्ता विरोधी लहर का फायदा उठाने की कोशिश में है. 4 मई को आने वाले नतीजे तय करेंगे कि तमिलनाडु की जनता 'द्रविड़ मॉडल' पर मुहर लगाती है या किसी नए विकल्प को चुनती है. `
  const newDesc = oldDesc
  // const newDesc = `Tamil Nadu Assembly Elections Results 2025: इस बार के तमिलनाडु विधानसभा चुनाव में कौन मारेगा बाजी? NDA या महागठबंधन...किसको मिलेगा बहुमत? BJP के साथ मिलकर JDU कर पाएगा कमाल या RJD और कांग्रेस की जोड़ी में VIP और लेफ्ट पार्टी मिल पलट देंगी गेम? नीतीश की बनेगी सरकार या प्रशांत किशोर की भविष्यवाणी होगी सच?  सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`;

  let metaData = {
    title: `Tamil Nadu Assembly Chunav  ${resultYear} Results: तमिलनाडु विधानसभा चुनाव रिजल्ट  ${resultYear} जानें सभी सीटों के नतीजे - NewsTak`,
    description: `Tamil Nadu Assembly Election  ${resultYear} Results: तमिलनाडु विधानसभा चुनाव  ${resultYear} के सभी सीटों के ताज़ा नतीजे और जीत-हार के आंकड़े देखें। जानें किस पार्टी को कितनी सीटें मिलीं और कौन बना रहा है सरकार — लाइव अपडेट्स के साथ।`,
    keywords: `तमिलनाडु विधानसभा चुनाव ${resultYear} परिणाम, Tamil Nadu Assembly Election ${resultYear} Results, Tamil Nadu Chunav Result ${resultYear}, Tamil Nadu Election Result Live, Tamil Nadu Vidhan Sabha Result, Tamil Nadu Election Seat Wise Result, तमिलनाडु सीटवार चुनाव नतीजे, Tamil Nadu Election Winner List, तमिलनाडु चुनाव वोट गिनती, Tamil Nadu Assembly Election Live Updates, किसे कितनी सीटें मिली तमिलनाडु चुनाव, Tamil Nadu Election Final Result ${resultYear}`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}

          electionPath={`${electionCategory}/results`}
          isMobileDevice={isMobileDevice}

          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="tamil_nadu_election"
          stateName={"Tamil Nadu"} //"Delhi"
          stateHindi={"तमिलनाडु"}
          metaData={metaData}
          oldResult={oldResult}
          oldDesc={oldDesc}
          newDesc={newDesc}
          resultKey={"partiesDataBR"}
          constituencyListData={constituencyListData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/results")[0];

  let electionCategory = url.split("/elections/")[1];

  if (!electionCategory) {
    return {
      notFound: true,
    };
  }

  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });
    let electionConfigData = null;
    const electionConfig = await fetch(
      `${process.env.BASE_PATH + process.env.API_PREFIX
      }/masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.tamil_nadu_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
        ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1 || []; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    }).catch((error) => {
      logger.error("Error fetching constituency list data:", error);
      constituencyListData = [];
    });
    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 120);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        constituencyListData,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
